import { ref, computed, onMounted, onUnmounted } from 'vue'
import { io } from 'socket.io-client'
import { useUserStore } from '@/stores/user.js'
import apiClient from '@/api/apiClient'

const socket = io(import.meta.env.VITE_SOCKET_URL);

const LIMIT = 10

export const useSocket = () => {
    const userStore = useUserStore()
    const notifications = ref([])
    const hasMore = ref(true)
    const loading = ref(false)
    const page = ref(1)

    const fetchNotifications = async () => {
        if (loading.value) return
        loading.value = true
        page.value = 1
        hasMore.value = true
        try {
            const { data } = await apiClient.get(`/notifications/get/by-user`, {
                params: { page: 1, limit: LIMIT }
            })
            const items = data.data ?? []
            notifications.value = items
            hasMore.value = items.length === LIMIT
            page.value = 2
        } catch (error) {
            // silent
        } finally {
            loading.value = false
        }
    }

    const loadMore = async () => {
        if (loading.value || !hasMore.value) return
        loading.value = true
        try {
            const { data } = await apiClient.get(`/notifications/get/by-user`, {
                params: { page: page.value, limit: LIMIT }
            })
            const items = data.data ?? []
            notifications.value = [...notifications.value, ...items]
            hasMore.value = items.length === LIMIT
            page.value++
        } catch (error) {
            // silent
        } finally {
            loading.value = false
        }
    }

    const listenNotifications = () => {
        socket.on('notification', (msg) => {
            if (typeof msg.status === 'undefined') msg.status = false
            notifications.value = [msg, ...notifications.value]
        })
    }

    const registerUser = () => {
        const uid = userStore.getUid()
        if (uid) {
            socket.emit('registerUser', uid)
        }
    }

    const unreadCount = computed(() => {
        return notifications.value.filter((noti) => noti.status === false).length
    })

    onMounted(() => {
        registerUser()
        listenNotifications()
        fetchNotifications()
    })

    onUnmounted(() => {
        socket.off('notification')
    })

    return { notifications, unreadCount, fetchNotifications, loadMore, hasMore, loading }
}
